import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';
import { Browser } from '@capacitor/browser';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

//import classes from './Modal_ViewModal.module.css';
import '../../../css/layout.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewReportsModal (props) {

    let auth_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(auth_context.acctID);
    let [sessionID, setSessionID ] = useState(auth_context.sessionID);
    let [baseURL, setBaseURL ] = useState(auth_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [reportTimeline, setReportTimeline] = useState('OVERALL');
    let [attachement, setAttachment] = useState(null);


    function generateReport()
    {


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '00_generateFinancials',
                user: acctID,
                xReportTimeline: reportTimeline,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            //alert(data);

            let rows = data.toString().split('~~~');

            //let rowLength = rows.length;

                //for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                //{
                    let cols = rows[0].split('|');
                    //alert(cols[0]);
                   // alert(cols[1]);

                    setAttachment(cols[0]);
                //}

                const timestamp = new Date().getTime(); // Ensures uniqueness
                const url = `${baseURL}${cols[0]}?t=${timestamp}`;
                Browser.open({ url });
        })
        .catch(error => {
            console.error(error);
        })
    }

    function openBroswer(){

        //alert( baseURL);
        //alert( props.data.fileLocation);
        //alert( baseURL+props.data.fileLocation);
        const timestamp = new Date().getTime(); // Ensures uniqueness
        const url = `${baseURL}${attachement}?t=${timestamp}`;
        Browser.open({ url });
        //Browser.open({ url: baseURL+attachement}).then(() => {});

    }

    function closeModalHandler(event) {

        props.closeModal(event);
    }
 



    return (

        <React.Fragment> 
           
                {
                props.openModal == true ?
                (
                <IonModal isOpen={ props.openModal }>
                    <IonHeader style={{color: "black"}}>
                        <h3> REPORTS </h3>
                    </IonHeader>

                    <IonContent className='appContent'>
                        <IonGrid >
                            <IonRow >
                                    <IonCol size='12'> <h3> FINANCIALS </h3> </IonCol>
                            </IonRow>
                            <IonRow >
                                    <IonCol size='12'> 
                                        <select name="businesstype" id='businesstype' onChange={(e) => setReportTimeline(e.target.value) }>
                                            <option value='YTD'>YEAR-TO-DATE</option>
                                            <option value='3YR'>3 Year Financials</option>
                                            <option value='OVERALL'  selected='selected'>Total Financials</option>
                                        </select>
                                    </IonCol>
                                    <IonCol>
                                        <IonButton onClick={() => generateReport()}>View</IonButton>
                                        {/*<IonButton onClick={() => openBroswer()}>View</IonButton>*/}
                                    </IonCol>
                                    
                            </IonRow>
                        </IonGrid>
                    </IonContent>

                    <IonFooter className='grid_footer'>
                        <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
                    </IonFooter>

                    </IonModal>) : null
                } 
        </React.Fragment>

    )
}